import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function Minus({ outline, ...props }: IconProps): JSX.Element {
  return outline ? <Minus.Outline {...props} /> : <Minus.Solid {...props} />;
}

Minus.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        <path
          d="M4.92896 11C4.37667 11 3.92896 11.4477 3.92896 12C3.92896 12.5523 4.37667 13 4.92896 13L19.0711 13C19.6234 13 20.0711 12.5523 20.0711 12C20.0711 11.4477 19.6234 11 19.0711 11H4.92896Z"
          fill="currentColor"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

Minus.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        <path
          d="M4.92896 11C4.37667 11 3.92896 11.4477 3.92896 12C3.92896 12.5523 4.37667 13 4.92896 13L19.0711 13C19.6234 13 20.0711 12.5523 20.0711 12C20.0711 11.4477 19.6234 11 19.0711 11H4.92896Z"
          fill="currentColor"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
